import React from "react";

const ColorBlindContext = React.createContext({});

export const ColorBlindProvider = ColorBlindContext.Provider;
export const ColorBlindConsumer = ColorBlindContext.Consumer;

export default ColorBlindContext;
